import styled from 'styled-components';

export const CreateUserButtonWrapper = styled.div`
  margin-bottom: 24px;
`;

export const FormField = styled.div`
  margin-bottom: 20px;
`;

export const SelectLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: ${(props) => props.theme['color.text.body']};
`;

export const Select = styled.select`
  width: 100%;
  min-width: 160px;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid ${(props) => props.theme['color.grayLight']};
  border-radius: 4px;
  background: ${(props) => props.theme['color.background']};
  color: ${(props) => props.theme['color.text.body']};
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ReadOnlyInput = styled.input`
  width: 100%;
  min-width: 160px;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid ${(props) => props.theme['color.grayLight']};
  border-radius: 4px;
  background: ${(props) => props.theme['color.grayLightest'] || '#f5f5f5'};
  color: ${(props) => props.theme['color.text.body']};
  box-sizing: border-box;
`;
